export default __webpack_public_path__ + "media/section-3.png";